import React from 'react'

import { alpha } from '@mui/material'
import { localizedStrings } from '@core/strings'
import { Collapsible } from '@common/Collapsible'
import { TimelineBlockBase } from '@common/Timeline/blocks'
import { Text, Box, Flex, Image } from '@fundamentals'

type TimelineBriefingSessionRoleCardProps = {
  roleText: string
  participants: {
    firstName: string
    lastName: string
    company: string
    signatureUrl: string
  }[]
  briefingText?: string // Not present for legacy briefings
}

const TimelineBriefingSessionRoleCard: React.FC<
  TimelineBriefingSessionRoleCardProps
> = ({ roleText, participants, briefingText }) => {
  return (
    <TimelineBlockBase>
      <Text variant='body2'>{roleText}</Text>

      {participants.map((participant, index) => {
        const isLast = index === participants.length - 1
        return (
          <Flex
            key={index}
            alignItems='center'
            borderBottom={isLast ? 'none' : `1px solid ${alpha('#000', 0.12)}`}
            pt={1.5}
            pb={isLast ? 0 : 1.5}
          >
            <Box flex={1}>
              <Text variant='body2' sx={{ mb: 0.5, mr: 1.5 }}>
                {`${participant.firstName} ${participant.lastName}`}
              </Text>
              <Text fontSize={12} color='grey'>
                {participant.company}
              </Text>
            </Box>

            {!!participant.signatureUrl && (
              <Image
                style={{ height: 40, objectFit: 'contain' }}
                src={participant.signatureUrl}
              />
            )}
          </Flex>
        )
      })}

      {!!briefingText && (
        <Collapsible
          label={{
            collapsed: localizedStrings.viewBriefingText,
            open: localizedStrings.hideBriefingText,
          }}
          buttonProps={{
            size: 'small',
            sx: { mt: 1, mb: -0.5 },
          }}
          hideIcon
          collapsed
        >
          <Box mt={2}>
            <Text fontSize={12} color='grey' mb={0.5}>
              {localizedStrings.briefingText}
            </Text>
            <Text
              dangerouslySetInnerHTML={{ __html: briefingText }}
              sx={{ '& p': { fontSize: '14px', mb: 0 } }}
            />
          </Box>
        </Collapsible>
      )}
    </TimelineBlockBase>
  )
}

export { TimelineBriefingSessionRoleCard }
